import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var DollarSign = createReactComponent("DollarSign", ["svg", defaultAttributes, [["line", {
  x1: "12",
  y1: "1",
  x2: "12",
  y2: "23",
  key: "1gx242"
}], ["path", {
  d: "M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6",
  key: "3516nr"
}]]]);
export default DollarSign;